var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Flyer"}},[_c('div',{staticClass:"tab-text"},[_c('flyer')],1)]),_c('vs-tab',{attrs:{"label":"Flyer History"}},[_c('div',{staticClass:"tab-text"},[_c('flyer-history')],1)]),_c('vs-tab',{attrs:{"label":"Flyer Allocation"}},[_c('div',{staticClass:"tab-text"},[_c('flyer-territory')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }